import { render } from "./GreenHelpCenter.vue?vue&type=template&id=b993cbde"
import script from "./GreenHelpCenter.vue?vue&type=script&lang=js"
export * from "./GreenHelpCenter.vue?vue&type=script&lang=js"

import "./GreenHelpCenter.vue?vue&type=style&index=0&id=b993cbde&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__